import { cn } from "@/lib/utils";
import { CoworkerIcon } from "@/components/ui/coworker-icon";
import { AnimatedImage } from "@/components/ui/animated-image";
import { PopoverRow } from "@/components/ui/popover-row";
import { POPOVER_SURFACE_CLASSES } from "@/lib/surface-styles";

interface MentionPopoverProps {
  users: {
    id: string;
    display_name: string;
    avatar_url?: string | null;
    is_coworker?: boolean | null;
  }[];
  onSelect: (user: { id: string; display_name: string }) => void;
  selectedIndex: number;
}

export function MentionPopover({
  users,
  onSelect,
  selectedIndex,
}: MentionPopoverProps) {
  if (users.length === 0) return null;

  return (
    <div
      className={cn(POPOVER_SURFACE_CLASSES, "max-h-60 w-64 overflow-y-auto")}
    >
      {users.map((user, i) => (
        <PopoverRow
          key={user.id}
          isSelected={i === selectedIndex}
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(user);
          }}
        >
          <div className="flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-full bg-foreground/20 text-[10px] font-semibold">
            {user.avatar_url ? (
              <AnimatedImage
                src={user.avatar_url}
                alt={user.display_name}
                className="h-full w-full object-cover"
              />
            ) : (
              user.display_name.slice(0, 2).toUpperCase()
            )}
          </div>
          <span className="truncate">{user.display_name}</span>
          {user.is_coworker && (
            <CoworkerIcon size={12} className="ml-auto shrink-0" />
          )}
        </PopoverRow>
      ))}
    </div>
  );
}
